import { Wrench, Cpu, Disc3, Sparkles, Check } from "lucide-react";

const icons = [Wrench, Cpu, Disc3, Sparkles];
const images = [
  "https://images.unsplash.com/photo-1616728249167-1d50a55de3d9",
  "https://images.pexels.com/photos/4116193/pexels-photo-4116193.jpeg",
  "https://images.unsplash.com/photo-1691706268537-27b719ee00dd",
  "https://images.pexels.com/photos/8478225/pexels-photo-8478225.jpeg",
];

export const Services = ({ t }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-zinc-950 py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
          <div className="lg:col-span-5">
            <span className="overline">{t.services.overline}</span>
            <h2 className="font-heading mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tighter text-zinc-50">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="font-body text-zinc-400 text-base md:text-lg leading-relaxed">
              {t.services.subtitle}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-800">
          {t.services.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <article
                key={s.name}
                data-testid={`service-card-${i}`}
                className="group bg-zinc-950 hover:bg-zinc-900/80 transition-colors p-8 md:p-10 flex flex-col gap-6"
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 border border-zinc-800 group-hover:border-red-600/50 group-hover:bg-red-600/5 flex items-center justify-center transition-colors">
                      <Icon className="w-5 h-5 text-red-600" strokeWidth={1.8} />
                    </div>
                    <span className="font-body text-xs font-bold tracking-[0.25em] uppercase text-zinc-500">
                      0{i + 1}
                    </span>
                  </div>
                  <div className="w-24 h-24 md:w-32 md:h-32 overflow-hidden border border-zinc-800 shrink-0">
                    <img
                      src={images[i]}
                      alt={s.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                    />
                  </div>
                </div>

                <div>
                  <h3 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-zinc-50">
                    {s.name}
                  </h3>
                  <p className="font-body mt-3 text-zinc-400 leading-relaxed">
                    {s.desc}
                  </p>
                </div>

                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-2 pt-6 border-t border-zinc-900">
                  {s.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-start gap-2 font-body text-sm text-zinc-300"
                    >
                      <Check
                        className="w-4 h-4 text-red-600 mt-0.5 shrink-0"
                        strokeWidth={2.4}
                      />
                      {f}
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
